module.exports = __webpack_public_path__ + "img/wizard-subscribe-form.982afed8.png";